export default function Tabs(theme) {
  return {
    MuiTabs: {
      styleOverrides: {
        root: {
          height: '32px',
          minHeight: '32px',
          marginTop: theme.spacing(1),
          marginBottom: theme.spacing(1),
          // minHeight: 'unset',
          // height: 38,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          height: '32px',
          minHeight: '32px',

          //   padding: 0,
          //   fontSize: theme.typography.h6.fontSize,
          //   fontWeight: theme.typography.fontWeightMedium,
          //   borderTopLeftRadius: theme.shape.borderRadius,
          //   borderTopRightRadius: theme.shape.borderRadius,
          //   '&.Mui-selected': {
          //     color: theme.palette.text.primary,
          //   },
          //   '&:not(:last-of-type)': {
          //     marginRight: theme.spacing(5),
          //   },
          //   '@media (min-width: 600px)': {
          //     minWidth: 48,
          //   },
          // },
          labelIcon: {
            minHeight: '32px',
            // flexDirection: 'row',
            // '& > *:first-of-type': {
            //   marginBottom: 0,
            //   marginRight: theme.spacing(1),
            // },
          },
          // wrapper: {
          //   flexDirection: 'row',
          //   whiteSpace: 'nowrap',
          // },

          '&.Mui-selected': {
            color: theme.palette.text.primary,
            fontWeight: theme.typography.fontWeightMedium,
            borderBottom: `2px solid ${theme.palette.primary.main}`,
          },
        },
      },
    },
    // MuiTabPanel: {
    //   styleOverrides: {
    //     root: {
    //       padding: 0,
    //     },
    //   },
    // },
    MuiTabScrollButton: {
      styleOverrides: {
        root: {
          width: '32px',
          minHeight: '32px',

          // borderRadius: '50%',
        },
      },
    },
  };
}
